/**
 * Implements the `NumberAnimation` component.
 *
 * This component enhances the `NumberDisplay` component by adding a sliding animation effect
 * whenever the number value changes. The new value slides from the bottom, replacing the old value
 * that slides out from the top.
 */
import { useState, useEffect } from 'react';
import NumberDisplay, { INumberDisplayProps } from '../NumberDisplay';

import './styles.scss';

const NumberAnimation = (props: INumberDisplayProps) => {
  const [current, setCurrent] = useState<INumberDisplayProps>(props);

  useEffect(() => {
    let timer: number;
    if (current.value !== props.value) {
      timer = window.setTimeout(() => {
        setCurrent(props);
      }, 500);
    }

    return () => {
      if (current.value !== props.value) {
        window.clearTimeout(timer);
      }
    };
  }, [props]);

  const getTransform1 = (number?: number) => {
    if (number === current.value) {
      return { transform: 'translateY(-100%)' };
    }
    return { transition: 'transform 0.5s', transform: 'translateY(-0)' };
  };

  const getTransform2 = (number?: number) => {
    if (number === props.value) {
      return { transform: 'translateY(0)' };
    }
    return { transition: 'transform 0.5s', transform: 'translateY(100%)' };
  };

  return (
    <div className='number_container'>
      <div
        className='number_container__item number_container__item--1'
        style={{ ...getTransform1(props.value) }}
      >
        <NumberDisplay {...props} />
      </div>
      <div className='number_container__ghost'>
        <NumberDisplay
          {...props}
          startSymbol={(props.startSymbol || '') + '0'}
        />
      </div>
      <div
        className='number_container__item number_container__item--2'
        style={{ ...getTransform2(current.value) }}
      >
        <NumberDisplay {...current} />
      </div>
    </div>
  );
};

export default NumberAnimation;
